export default {
  title: 'Buyer data'
}
